import { api } from './api';

export const fetchInvoices = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/invoice', params, options);
};

export const fetchInvoiceSources = (params) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/invoice/source_name', params);
};

export const fetchInvoiceById = (id) => {
  return api.get(`/invoice/${id}`);
};

export const fetchProcessInvoiceById = (id, params) => {
  return api.post(`/invoice/${id}/process`, params);
};

export const fetchMarkInvoicesAsPaidByIds = (ids) => {
  const params = new URLSearchParams(ids.map((id) => ['invoice_ids', id]));
  return api.post(`/invoice/bulk/external_paid?${params.toString()}`);
};

export const fetchAddItemToInvoice = (payload) => {
  return api.post('/invoice/invoice_item', payload);
};

export const fetchUpdateInvoiceApproval = (id, payload) => {
  return api.put(`/invoice/${id}/request`, payload);
};

export const fetchDeleteItemFromInvoice = (id) => {
  return api.delete(`/invoice/invoice_item/${id}`);
};

export const fetchUpdateInvoiceItem = (id, payload) => {
  return api.put(`/invoice/invoice_item/${id}`, payload);
};

export const fetchSendInvoiceByEmail = (id, params) => {
  return api.get(`/invoice/${id}/send_email`, params);
};

export const fetchExportInvoice = (id, type) => {
  return api.get(`/invoice/${id}/export`, {type}, { responseType: 'blob'});
};

export const fetchRefund = (payload) => {
  return api.post(`/invoice/refund`, payload);
};

export const fetchCreateInvoice = (payload) => {
  return api.post('/invoice', payload);
};

export const fetchDeleteInvoice = (id) => {
  return api.delete(`/invoice/${id}`);
};

export const fetchUpdateInvoice = (id, payload) => {
  return api.put(`/invoice/${id}`, payload);
};

export const fetchProcessInvoicesByIds = (invoiceIds) => {
  const params = new URLSearchParams(invoiceIds.map((id) => ['invoice_ids', id]));
  return api.post(`/invoice/bulk/process?${params.toString()}`);
};
